export const fields = [
  {
    label: "Weight Goal",
    key: "weightGoal",
    type: "select",
    options: ["Weight Loss", "Weight Stabilization", "Weight Gain"],
  },
  {
    label: "Condition Goal",
    key: "conditionGoal",
    type: "select",
    options: ["Improve Condition", "Maintain Condition", "Not Applicable"],
  },
  {
    label: "Diet Type",
    key: "dietaryPreferences",
    type: "multi-select",
    options: [
      "General",
      // "Standard",
      "Low-Calorie",
      "Bread Products",
      "Dairy Products",
      "Paleo",
      "Gluten-Free",
      "Intermittent Fasting",
      "Lactose-Free",
      "Diabetes-Friendly",
      "High-Fibre",
      "Low-Sodium",
      "Vegetarian",
      "Vegan",
      "Low-Carb",
      "Mediterranean",
      "Halal",
      "Kosher",
      "Flexitarian",
      "Carnivore",
      "Ketogenic",
      "High-Protein",
      "Low-Fat",
    ],
  },
  {
    label: "Food Budget",
    key: "foodBudget",
    type: "select",
    options: ["High", "Average", "Low"],
  },
  {
    label: "Preparation Time",
    key: "preparationTime",
    type: "select",
    options: [
      "Quick and Easy (10 - 20 minutes)",
      "Moderate Cooking Time (20 - 35 minutes)",
      "Extended & Flavorful (35+ minutes)",
    ],
  },
  {
    label: "Breakfast Taste Preferences",
    key: "breakfastTastePreferences",
    type: "multi-select",
    options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
  },
  {
    label: "Lunch Taste Preferences",
    key: "lunchTastePreferences",
    type: "multi-select",
    options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
  },
  {
    label: "Dinner Taste Preferences",
    key: "dinnerTastePreferences",
    type: "multi-select",
    options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
  },
  {
    label: "Afternoon Snacks",
    key: "afternoonSnacks",
    type: "multi-select",
    options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
  },
  {
    label: "Evening Snacks",
    key: "eveningSnacks",
    type: "multi-select",
    options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
  },
  {
    label: "Multi Cusine",
    key: "multiCusine",
    type: "multi-select",
    options: [
      "African",
      "American (Traditional)",
      "American (Southern / Soul Food)",
      "Arabian / Middle Eastern",
      "Asian Fusion",
      "Balkan",
      "British / English",
      "Caribbean",
      "Central European",
      "Chinese (Cantonese/Sichuan etc.)",
      "Dutch",
      "Eastern European",
      "Filipino",
      "French",
      "German",
      "Greek",
      "Indian (North)",
      "Indian (South)",
      "Indonesian",
      "Iranian / Persian",
      "Irish",
      "Israeli",
      "Italian",
      "Japanese",
      "Jewish",
      "Korean",
      "Latin American",
      "Lebanese",
      "Malaysian",
      "Mediterranean",
      "Mexican",
      "Moroccan",
      "Nordic / Scandinavian",
      "Polish",
      "Portuguese",
      "Russian",
      "South African",
      "Southeast Asian (general)",
      "Spanish",
      "Surinamese",
      "Swiss",
      "Thai",
      "Turkish",
      "Vietnamese",
      "West African",
      "Western European",
      "Vegetarian European",
      "Vegan Global",
      "Light & Balanced (International)",
      "Comfort Food (International)",
      "Pakistani",
    ],
  },
  {
    label: "Exclude this Exotic Dish",
    key: "exoticDishes",
    type: "multi-select",
    options: [
      "None",
      "Insects",
      "Raw Seafood",
      "Offal",
      "Fermented Fish",
      "Frog Legs",
      "Century Eggs",
      "Blood-based-Dishes",
      "Animal Brains",
      "Balut (fertilized duck egg)",
      "Exotic Game Meats",
    ],
  },
  {
    label: "Regional Food Country",
    key: "selectedCountry",
    type: "country-select",
    options: [],
  },
  {
    label: "Health Conditions",
    key: "healthConditions",
    type: "multi-select",
    options: [
      "None",
      "High Blood Pressure",
      "High Cholesterol",
      "Diabetes",
      "Thyroid Problems",
      "Cardiovascular Diseases",
      "Rheumatic Disorders",
      "Chronic Kidney Disease",
      "Gastrointestinal Issue",
      "Aesthma",
      "COPD",
    ],
  },
  {
    label: "Food Allergies",
    key: "foodAllergies",
    type: "multi-select",
    options: [
      "None",
      "Dairy",
      "Gluten",
      "Nuts",
      "Eggs",
      "Fish & Shellfish",
      "Peanuts",
      "Soy",
      "Fruit",
      "Sulfites/Preservatives",
      "Sesame Seeds",
    ],
  },
  {
    label: "Your Age",
    key: "yourAge",
    type: "numeric",
    options: [],
  },
  {
    label: "Height",
    key: "height",
    type: "numeric",
    options: [],
  },
  {
    label: "Weight",
    key: "weight",
    type: "numeric",
    options: [],
  },
  {
    label: "Waist Circumference",
    key: "waistCircumference",
    type: "numeric",
    options: [],
  },
  {
    label: "Target Weight",
    key: "targetWeight",
    type: "numeric",
    options: [],
  },
  {
    label: "Activity",
    key: "activity",
    type: "select",
    options: [
      "Basal Metabolic Rate (BMR)",
      "Sedentary (little or no exercise)",
      "Light (exercise 1-3 times/week)",
      "Moderate (exercise 4-5 times/week)",
      "Active (daily exercise or intense exercise 3-4 times/week)",
      "Very Active (intense exercise 6-7 times/week)",
      "Extra Active (very intense exercise daily, or physical job)",
    ],
  },
  {
    label: "Timeline",
    key: "timeline",
    type: "select",
    options: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ],
  },
  {
    label: "Week/Months",
    key: "durationType",
    type: "select",
    options: ["Week", "Month"],
  },
  {
    label: "Maintenance Calories (Kcal)",
    key: "maintenanceCalories",
    type: "numeric",
    options: [],
  },
  {
    label: "Target Daily Calories (Kcal)",
    key: "targetDailyCalories",
    type: "numeric",
    options: [],
  },
  {
    label: "Daily Calorie Adjustment (Kcal)",
    key: "dailyCalorieAdjustment",
    type: "numeric",
    options: [],
  },
];
